import React, { memo } from 'react';
import FormikWrapper from '../FormikWrapper';
import type { InputFieldFactoryProps } from '../Factory/InputFieldFactory';
import type { useFormikContext } from 'formik';
import InternalArrayField from './InternalArrayField';

export type ArrayFieldProps = Pick<InputFieldFactoryProps, 'className' | 'field' | 'hideErrorText'> & {
  isEditing?: boolean;
};

const ArrayField = (props: ArrayFieldProps) => {
  return (
    <FormikWrapper>
      {(formik: ReturnType<typeof useFormikContext>) => <InternalArrayField formik={formik} {...props} />}
    </FormikWrapper>
  );
};

export default memo(ArrayField);
